// Confirmacao da PRIMEIRA senha. Reusa o CSS do sucessRedefinePassword.
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/button/Button';
import { useBrandContext } from '../../../context/BrandContext';

import '../../redefinePassword/sucessRedefinePassword/SucessRedefinePassword.css';

const SucessWelcomePassword = () => {
  const navigate = useNavigate();

  const brandContext = useBrandContext();

  return (
    <div className='sucess-switch-password-wrapper'>
      <div className='sucess-switch-password-container'>
        <div className='sucess-switch-password-fields'>
          <span className='sucess-switch-password-title'>Senha criada</span>
          <span className='sucess-switch-password-subtitle'>
            Tudo certo para o login no app
          </span>
          <Button
            style={{
              backgroundColor: brandContext.brandBgColor
                ? brandContext.brandBgColor
                : '#3CCC10',
              color: '#FFFFFF',
              marginTop: '33px',
            }}
            type='button'
            children='Ir para login'
            onClick={() => navigate(`/${brandContext.brandName}/login`)}
          />
        </div>
      </div>
    </div>
  );
};

export default SucessWelcomePassword;
